module.exports = __webpack_public_path__ + "img/max-cloud-check.c2d7af80.svg";